import React, { useState, useEffect } from "react";
import { Card, Col, Container, Row, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { jsonParseFromLocalStorage } from "../../Funcs/Miscellaneous";
import { ClinicsData } from "../../Utils/constants";

const ClinicCardSelection = () => {
  const { t, i18n } = useTranslation();
  const [currentClinic, setCurrentClinic] = useState(
    jsonParseFromLocalStorage("currentClinic", ClinicsData["Default"])
  );
  const [clinics, setClinics] = useState([]);
  const [loading, setLoading] = useState(true);

  const db = getFirestore();

  useEffect(() => {
    const fetchClinics = async () => {
      setLoading(true);
      try {
        const snapshot = await getDocs(collection(db, "clinicsData"));
        const fetchedClinics = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setClinics(fetchedClinics);
      } catch (error) {
        console.error("Error fetching clinics:", error);
      }
      setLoading(false);
    };

    fetchClinics();
  }, [db]);

  const handleClinicChange = (clinic) => {
    localStorage.setItem("currentClinic", JSON.stringify(clinic)); // Store as JSON string
    setCurrentClinic(clinic); // Update state
    window.location.reload(); // Reload to apply clinic-specific data
  };

  return (
    <Container className="mt-4">
      <h2 className="text-center">{t("SelectClinic")}</h2>
      {loading ? (
        <Spinner animation="border" className="d-block mx-auto" />
      ) : (
        <Row className="mt-3">
          {clinics.map((clinic) => (
            <Col md={4} sm={6} xs={12} key={clinic.id} className="mb-4">
              <Card
                onClick={() => handleClinicChange(clinic)}
                style={{
                  cursor: "pointer",
                  border:
                    currentClinic && currentClinic.id === clinic.id
                      ? "5px solid #307bff"
                      : "1px solid #ddd",
                  transition: "transform 0.2s",
                  backgroundColor: clinic.color,
                  color: "white",
                }}
                className="h-100"
              >
                <Card.Body className="text-center">
                  <Card.Title>
                    {i18n.language === "ar" ? clinic.arLabel : clinic.enLabel}
                  </Card.Title>
                  <img style={{ maxWidth: "70%" }} src={currentClinic.logo} />
                </Card.Body>
              </Card>
              {/* {currentClinic && currentClinic.id === clinic.id && <hr />} */}
            </Col>
          ))}
        </Row>
      )}
    </Container>
  );
};

export default ClinicCardSelection;
